import { Separator } from '@acme/foundation';
import {
  $applicationLiquidityProviders,
  applicationOpened,
} from '@entities/application';
import { ApplicationProvidersTable } from '@widgets/providersTable';
import { useUnit } from 'effector-react';
import { useParams } from 'react-router-dom';

export const LiquidityProvidersCard = () => {
  const { id } = useParams();
  const { providers, onApplicationOpened } = useUnit({
    providers: $applicationLiquidityProviders,
    onApplicationOpened: applicationOpened,
  });

  if ((providers?.length ?? 0) === 0) return null;

  return (
    <>
      <Separator className="-mx-6" />
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-900">
          Поставщики ликвидности
        </h2>
      </div>

      <ApplicationProvidersTable
        className="-mx-6"
        providers={providers}
        applicationId={id}
        onUploadSuccess={id ? () => onApplicationOpened({ id }) : undefined}
      />
    </>
  );
};
